module.exports = __webpack_public_path__ + "static/media/logo-mapeala-final.a3d4de0c.png";